import { NavigationRoutes } from 'common/constants';
import { themedStyled } from 'common/styles/styletron.theme';
import HOCInput from 'components/common/hoc-input';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import {
  CardSection,
  HalfContainer,
  // OneQuarterContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function PurchaseDetail() {
  const { t } = useTranslation();
  const { navigate } = useNavigation();
  const onViewOldData = ({ id, transactionType }) => {
    const params = {
      id,
    } as const;

    switch (transactionType) {
      case 'activity':
        navigate(NavigationRoutes.ActivityPurchasesView, params);
        break;
      case 'cruise':
        navigate(NavigationRoutes.CruisePurchasesView, params);
        break;
      case 'flight':
        navigate(NavigationRoutes.FlightPurchasesView, params);
        break;
      case 'hotel':
        navigate(NavigationRoutes.HotelPurchasesView, params);
        break;
      case 'product':
        navigate(NavigationRoutes.ProductPurchasesView, params);
        break;
      case 'document':
        navigate(NavigationRoutes.DocumentPurchasesView, params);
        break;
      default:
        break;
    }
  };

  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <SectionContainer>
        <Text variant="HeadingXSmall">{t('ticketOrders:orders-details')}</Text>
        <HOCInput keys={['approvalable']}>
          {(value) => {
            if (
              value.approvalable.status === 'waiting' ||
              !value.approvalable.waitingId
            ) {
              return <></>;
            }
            return (
              <Button
                buttonType="secondary"
                onClick={() =>
                  onViewOldData({
                    id: value.approvalable.waitingId,
                    transactionType: value.approvalable.transactionType,
                  })
                }
              >
                {t('common:view_old_data')}
              </Button>
            );
          }}
        </HOCInput>
      </SectionContainer>
      <Separator gap={16} />
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.number"
            label={t('common:order_number')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="approvalable.transactionAt"
            label={t('common:date')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.type"
            label={t('common:type')}
          />
        </HalfContainer>
        <HalfContainer>
          <HOCInput keys={['approvalable.type']}>
            {(_value) => {
              const value = _value['approvalable.type'];
              const name =
                value === 'Sales'
                  ? 'approvalable.invoiceNumber'
                  : value === 'Tour'
                  ? 'approvalable.tourLabel'
                  : '';
              const label =
                value === 'Sales'
                  ? t('common:invoice_number')
                  : value === 'Tour'
                  ? t('common:tour')
                  : '';
              if (!name) {
                return <></>;
              }
              return <Input type="text" name={name} label={label} />;
            }}
          </HOCInput>
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.agent"
            label={t('common:agent')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.paymentChannel"
            label={t('common:payment_channel')}
          />
        </HalfContainer>
      </SectionContainer>
      {/* <Text variant="LabelMedium">{t('agent:pic')}</Text>
      <Separator gap={16} />
      <SectionContainer>
        <OneQuarterContainer>
          <Input
            type="text"
            name="approvalable.pic.name"
            label={t('common:name')}
            placeholder={t('common:name')}
            disabled
          />
        </OneQuarterContainer>
        <OneQuarterContainer>
          <Input
            type="email"
            name="approvalable.pic.email"
            label={t('common:email')}
            placeholder={t('common:email')}
            disabled
          />
        </OneQuarterContainer>
        <OneQuarterContainer>
          <Input
            type="tel"
            name="approvalable.pic.phone"
            label={t('common:phone_number')}
            placeholder={t('common:phone_number')}
            disabled
          />
        </OneQuarterContainer>
        <OneQuarterContainer>
          <Input
            type="text"
            name="approvalable.pic.description"
            label={t('common:description')}
            placeholder={t('common:description')}
            disabled
            noMargin
          />
        </OneQuarterContainer>
      </SectionContainer> */}
    </CardSection>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
